import React from 'react'
import { Select } from '@resurs/midas-react'
import { getText } from '../../../../internal/TextLabels'
import { CustomerTypeModel } from '../../models/private-models'
import { padEnd } from '../../../../util/helpers'

const _formatCardDescription = ({
  cardNumber,
  accountNumber,
  cardHolderName,
  cardHolderGovernmentId,
}) =>
  (cardHolderName &&
    `${padEnd(cardHolderName, 24, '\u00A0')} ${cardHolderGovernmentId}`) ||
  cardNumber ||
  accountNumber

const CardInformationSelect = ({
  availableCards = [],
  customerType,
  selectedCard,
  onChangeCard,
  hideMasked,
}) => {
  const cardsToPresent =
    customerType === CustomerTypeModel.LEGAL
      ? availableCards
          .filter(
            c => c.cardNumber && !(c.cardNumber.includes('X') && hideMasked),
          )
          .map(c => ({
            key: c.cardNumber,
            value: c.cardNumber,
            valueLabel: _formatCardDescription(c),
          }))
      : availableCards

  if (cardsToPresent.length < 1) {
    return null
  }

  return (
    <Select
      id="card-information-selector"
      label={getText('payApply.accountInformation.selectCard')}
      {...(selectedCard
        ? {
            value: !(selectedCard.cardNumber.includes('X') && hideMasked)
              ? selectedCard.cardNumber
              : '',
            optionsLabel:
              selectedCard.cardNumber.includes('X') && hideMasked
                ? `${getText('payApply.accountInformation.selectCard')}...`
                : null,
          }
        : {
            optionsLabel: `${getText(
              'payApply.accountInformation.selectCard',
            )}...`,
          })}
      values={cardsToPresent}
      onChange={cardNumber => onChangeCard(cardNumber)}
    />
  )
}
export default CardInformationSelect
